import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressCard } from '@fortawesome/pro-solid-svg-icons/faAddressCard'
import { faAlarmClock } from '@fortawesome/pro-regular-svg-icons/faAlarmClock'
import { faAlignJustify } from '@fortawesome/pro-solid-svg-icons/faAlignJustify'
import { faAnglesUpDown } from '@fortawesome/pro-regular-svg-icons/faAnglesUpDown'
import { faAnglesLeft } from '@fortawesome/pro-solid-svg-icons/faAnglesLeft'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown'
import { faAngleDown as fasAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft'
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp'
import { faAngleUp as fasAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp'
import { faArrowsSpin } from '@fortawesome/pro-solid-svg-icons/faArrowsSpin'
import { faExpand } from '@fortawesome/pro-solid-svg-icons/faExpand'
import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons/faArrowToBottom'
import { faArrowToBottom as farArrowToBottom } from '@fortawesome/pro-regular-svg-icons/faArrowToBottom'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons/faArrowsRotate'
import { faArrowsAlt } from '@fortawesome/pro-solid-svg-icons/faArrowsAlt'
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp'
import { faSquareArrowDown } from '@fortawesome/pro-regular-svg-icons/faSquareArrowDown'
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowDown'
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan'
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell'
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase'
import { faArrowAltFromBottom } from '@fortawesome/pro-regular-svg-icons/faArrowAltFromBottom'
import { faSortNumericUp } from '@fortawesome/pro-regular-svg-icons/faSortNumericUp'
import { faParagraph } from '@fortawesome/pro-regular-svg-icons/faParagraph'
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding'
import { faBullseyeArrow } from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow'
import { faBoxes } from '@fortawesome/pro-regular-svg-icons/faBoxes'
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import { faCalendarAlt as falCalendarAlt } from '@fortawesome/pro-light-svg-icons/faCalendarAlt'
import { faCalendarArrowDown as farCalendarArrowDown } from '@fortawesome/pro-regular-svg-icons/faCalendarArrowDown'
import { faCamera } from '@fortawesome/pro-regular-svg-icons/faCamera'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp'
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft'
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { faChartNetwork } from '@fortawesome/pro-regular-svg-icons/faChartNetwork'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle'
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare'
import { faChevronDoubleLeft } from '@fortawesome/pro-solid-svg-icons/faChevronDoubleLeft'
import { faChevronDoubleRight } from '@fortawesome/pro-solid-svg-icons/faChevronDoubleRight'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { faClock as faSolidClock } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faClone } from '@fortawesome/pro-regular-svg-icons/faClone'
import { faCloudUpload } from '@fortawesome/pro-regular-svg-icons/faCloudUpload'
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog'
import { faCog as farCog } from '@fortawesome/pro-regular-svg-icons/faCog'
import { faColumns } from '@fortawesome/pro-solid-svg-icons/faColumns'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faCalendarCheck } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck'
import { faDatabase as farDatabase } from '@fortawesome/pro-regular-svg-icons/faDatabase'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { faEllipsisV as farEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV'
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import { faEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText'
import { faGaugeSimpleMax } from '@fortawesome/pro-regular-svg-icons/faGaugeSimpleMax'
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faExclamationTriangle as farExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { faExclamationTriangle as falExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash'
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt'
import { faFileContract as farFileContract } from '@fortawesome/pro-regular-svg-icons/faFileContract'
import { faFileImage } from '@fortawesome/pro-light-svg-icons/faFileImage'
import { faFileChartLine } from '@fortawesome/pro-regular-svg-icons/faFileChartLine'
import { faFileExcel as falFileExcel } from '@fortawesome/pro-light-svg-icons/faFileExcel'
import { faFileExport } from '@fortawesome/pro-regular-svg-icons/faFileExport'
import { faFileImport } from '@fortawesome/pro-regular-svg-icons/faFileImport'
import { faFileUpload } from '@fortawesome/pro-regular-svg-icons/faFileUpload'
import { faFileUpload as falFileUpload } from '@fortawesome/pro-light-svg-icons/faFileUpload'
import { faFlag } from '@fortawesome/pro-regular-svg-icons/faFlag'
import { faFlag as faSolidFlag } from '@fortawesome/pro-solid-svg-icons/faFlag'
import { faFlagAlt } from '@fortawesome/pro-solid-svg-icons/faFlagAlt'
import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder'
import { faFont as farFont } from '@fortawesome/pro-regular-svg-icons/faFont'
import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe'
import { faHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake'
import { faHeadset } from '@fortawesome/pro-solid-svg-icons/faHeadset'
import { faHourglassHalf } from '@fortawesome/pro-regular-svg-icons/faHourglassHalf'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faKey } from '@fortawesome/pro-regular-svg-icons/faKey'
import { faKey as falKey } from '@fortawesome/pro-light-svg-icons/faKey'
import { faLayerPlus } from '@fortawesome/pro-regular-svg-icons/faLayerPlus'
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup'
import { faListAlt } from '@fortawesome/pro-solid-svg-icons/faListAlt'
import { faListDropdown } from '@fortawesome/pro-regular-svg-icons/faListDropdown'
import { faListUl as falListUl } from '@fortawesome/pro-light-svg-icons/faListUl'
import { faList } from '@fortawesome/pro-regular-svg-icons/faList'
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink'
import { faLockAlt } from '@fortawesome/pro-regular-svg-icons/faLockAlt'
import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons/faLockKeyhole'
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot'
import { faLongArrowAltLeft as farLongArrowAltLeft } from '@fortawesome/pro-regular-svg-icons/faLongArrowAltLeft'
import { faLongArrowAltRight as farLongArrowAltRight } from '@fortawesome/pro-regular-svg-icons/faLongArrowAltRight'
import { faMapLocationDot } from '@fortawesome/pro-regular-svg-icons/faMapLocationDot'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import { faMapMarkerAlt as farMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt'
import { faMerge } from '@fortawesome/pro-regular-svg-icons/faMerge'
import { faMerge as fasMerge } from '@fortawesome/pro-solid-svg-icons/faMerge'
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus'
import { faMinus as falMinus } from '@fortawesome/pro-light-svg-icons/faMinus'
import { faMinusCircle } from '@fortawesome/pro-solid-svg-icons/faMinusCircle'
import { faMinusOctagon } from '@fortawesome/pro-light-svg-icons/faMinusOctagon'
import { faMinusSquare } from '@fortawesome/pro-solid-svg-icons/faMinusSquare'
import { faPennant } from '@fortawesome/pro-regular-svg-icons/faPennant'
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil'
import { faPencilAlt } from '@fortawesome/pro-regular-svg-icons/faPencilAlt'
import { faPhone as falPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPhone } from '@fortawesome/pro-regular-svg-icons/faPhone'
import { faPhoneArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faPhoneArrowUpRight'
import { faPhoneFlip } from '@fortawesome/pro-regular-svg-icons/faPhoneFlip'
import { faPhoneSlash } from '@fortawesome/pro-light-svg-icons/faPhoneSlash'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faLineChart } from '@fortawesome/pro-regular-svg-icons/faLineChart'
import { faProjectDiagram } from '@fortawesome/pro-regular-svg-icons/faProjectDiagram'
import { faPresentation } from '@fortawesome/pro-regular-svg-icons/faPresentation'
import { faPresentationScreen } from '@fortawesome/pro-regular-svg-icons/faPresentationScreen'
import { faQrcode } from '@fortawesome/pro-regular-svg-icons/faQrcode'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle'
import { faReceipt } from '@fortawesome/pro-regular-svg-icons/faReceipt'
import { faRedo } from '@fortawesome/pro-regular-svg-icons/faRedo'
import { faRepeat } from '@fortawesome/pro-regular-svg-icons/faRepeat'
import { faRepeat as falRepeat } from '@fortawesome/pro-light-svg-icons/faRepeat'
import { faRetweet as farRetweet } from '@fortawesome/pro-regular-svg-icons/faRetweet'
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faShare as farShare } from '@fortawesome/pro-regular-svg-icons/faShare'
import { faShieldAlt } from '@fortawesome/pro-regular-svg-icons/faShieldAlt'
import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut'
import { faSliders } from '@fortawesome/pro-regular-svg-icons/faSliders'
import { faSortSizeUpAlt } from '@fortawesome/pro-regular-svg-icons/faSortSizeUpAlt'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner'
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare'
import { faSquare as faSolidSquare } from '@fortawesome/pro-solid-svg-icons/faSquare'
import { faSquareList as falSquareList } from '@fortawesome/pro-light-svg-icons/faSquareList'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faStickyNote } from '@fortawesome/pro-regular-svg-icons/faStickyNote'
import { faSitemap } from '@fortawesome/pro-regular-svg-icons/faSitemap'
import { faSync } from '@fortawesome/pro-regular-svg-icons/faSync'
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable'
import { faTasks as farTask } from '@fortawesome/pro-regular-svg-icons/faTasks'
import { faText } from '@fortawesome/pro-regular-svg-icons/faText'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTimes as faTimesRegular } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle'
import { faTimesCircle as fasTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import { faTrashAlt as farTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { faTrashAlt as falTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt'
import { faTrashCanXmark as farTrashCanXmark } from '@fortawesome/pro-regular-svg-icons/faTrashCanXmark'
import { faTrashUndoAlt as farTrashUndoAlt } from '@fortawesome/pro-regular-svg-icons/faTrashUndoAlt'
import { faTrophyAlt } from '@fortawesome/pro-regular-svg-icons/faTrophyAlt'
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser'
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers'
import { faUserChart } from '@fortawesome/pro-regular-svg-icons/faUserChart'
import { faUserCheck } from '@fortawesome/pro-regular-svg-icons/faUserCheck'
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle'
import { faFilterCircleXmark } from '@fortawesome/pro-light-svg-icons/faFilterCircleXmark'
import { faUserTimes } from '@fortawesome/pro-regular-svg-icons/faUserTimes'
import { faUserLock } from '@fortawesome/pro-regular-svg-icons/faUserLock'
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus'
import { faWindowMinimize } from '@fortawesome/pro-regular-svg-icons/faWindowMinimize'
import { faPlusSquare } from '@fortawesome/pro-light-svg-icons/faPlusSquare'
import { faHexagonMinus as falHexagonMinus } from '@fortawesome/pro-light-svg-icons/faHexagonMinus'
import { faFileCheck } from '@fortawesome/pro-light-svg-icons/faFileCheck'
import { faFileChartColumn } from '@fortawesome/pro-regular-svg-icons/faFileChartColumn'
import { faFileExclamation } from '@fortawesome/pro-light-svg-icons/faFileExclamation'
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink'
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine'
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle'
import { faExclamationCircle as farExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle'
import { faDollarSign } from '@fortawesome/pro-regular-svg-icons/faDollarSign'
import { faLineHeight } from '@fortawesome/pro-solid-svg-icons/faLineHeight'
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons/faAsterisk'
import { faAddressBook } from '@fortawesome/pro-regular-svg-icons/faAddressBook'
import { faPercentage } from '@fortawesome/pro-solid-svg-icons/faPercentage'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faScreenUsers } from '@fortawesome/pro-solid-svg-icons/faScreenUsers'
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons/faPaperPlane'
import { faCirclePlay } from '@fortawesome/pro-solid-svg-icons/faCirclePlay'
import { faArrowsFromDottedLine } from '@fortawesome/pro-regular-svg-icons/faArrowsFromDottedLine'
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter'
import { faArrowUpRightAndArrowDownLeftFromCenter as faArrowUpRightAndArrowDownLeftFromCenterReg } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter'
import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/pro-solid-svg-icons/faArrowDownLeftAndArrowUpRightToCenter'
import { faArrowDownLeftAndArrowUpRightToCenter as faArrowDownLeftAndArrowUpRightToCenterReg } from '@fortawesome/pro-regular-svg-icons/faArrowDownLeftAndArrowUpRightToCenter'
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons/faPaperclip'
import { faSort } from '@fortawesome/pro-solid-svg-icons/faSort'
import { faMobileNotch } from '@fortawesome/pro-regular-svg-icons/faMobileNotch'
import { faBoxesStacked } from '@fortawesome/pro-regular-svg-icons/faBoxesStacked'
import { faMinusOctagon as faMinusOctagonReg } from '@fortawesome/pro-regular-svg-icons/faMinusOctagon'
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload'
import { faArrowUpRightDots } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightDots'
import { faFileInvoice } from '@fortawesome/pro-light-svg-icons/faFileInvoice'
import { faFileContract } from '@fortawesome/pro-light-svg-icons/faFileContract'
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faUpRightFromSquare'
import { faUpload } from '@fortawesome/pro-regular-svg-icons/faUpload'
import { faInboxIn } from '@fortawesome/pro-regular-svg-icons/faInboxIn'
import { faInboxOut } from '@fortawesome/pro-regular-svg-icons/faInboxOut'
import { faEnvelopeCircleCheck } from '@fortawesome/pro-regular-svg-icons/faEnvelopeCircleCheck'
import { faPenClip } from '@fortawesome/pro-regular-svg-icons/faPenClip'
import { faMessages } from '@fortawesome/pro-regular-svg-icons/faMessages'
import { faArrowsToDottedLine } from '@fortawesome/pro-regular-svg-icons/faArrowsToDottedLine'
import { faGripLinesVertical } from '@fortawesome/pro-regular-svg-icons/faGripLinesVertical'
import { faCircle as farCircle } from '@fortawesome/pro-regular-svg-icons/faCircle'
import { faArrowDownToDottedLine } from '@fortawesome/pro-solid-svg-icons/faArrowDownToDottedLine'
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause'
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode'
import { faStars } from '@fortawesome/pro-solid-svg-icons/faStars'
import { faArrowTurnDownLeft as farArrowTurnDownLeft } from '@fortawesome/pro-regular-svg-icons/faArrowTurnDownLeft'
import { faStore } from '@fortawesome/pro-regular-svg-icons/faStore'

export default () => {
  library.add(farArrowTurnDownLeft)
  library.add(faStars)
  library.add(faStore)
  library.add(faPenClip)
  library.add(faAddressCard)
  library.add(faAlarmClock)
  library.add(faAlignJustify)
  library.add(faAnglesUpDown)
  library.add(faAnglesLeft)
  library.add(faAngleDown)
  library.add(fasAngleDown)
  library.add(faAngleRight)
  library.add(faAngleLeft)
  library.add(faAngleUp)
  library.add(fasAngleUp)
  library.add(faArrowLeft)
  library.add(faArrowsAlt)
  library.add(faArrowsSpin)
  library.add(faExpand)
  library.add(faArrowToBottom)
  library.add(faArrowUpRightDots)
  library.add(farArrowToBottom)
  library.add(faArrowsRotate)
  library.add(faArrowUp)
  library.add(faArrowDown)
  library.add(faSquareArrowDown)
  library.add(faBan)
  library.add(faBell)
  library.add(faBullseyeArrow)
  library.add(faBoxes)
  library.add(faBriefcase)
  library.add(faBuilding)
  library.add(faCamera)
  library.add(faCaretDown)
  library.add(faCaretUp)
  library.add(faCaretLeft)
  library.add(faCaretRight)
  library.add(faCalendarAlt)
  library.add(falCalendarAlt)
  library.add(farCalendarArrowDown)
  library.add(faChartNetwork)
  library.add(faCheck)
  library.add(fasCheckCircle)
  library.add(faCheckCircle)
  library.add(faCheckSquare)
  library.add(faChevronDoubleLeft)
  library.add(faChevronDoubleRight)
  library.add(faChevronDown)
  library.add(faChevronLeft)
  library.add(faChevronRight)
  library.add(faChevronUp)
  library.add(faCircle)
  library.add(farCircle)
  library.add(fasBars)
  library.add(faClock)
  library.add(faClone)
  library.add(faCloudUpload)
  library.add(faCog)
  library.add(faColumns)
  library.add(faCopy)
  library.add(farDatabase)
  library.add(faEllipsisV)
  library.add(faEnvelope)
  library.add(faEnvelopeOpenText)
  library.add(faGaugeSimpleMax)
  library.add(faExclamationTriangle)
  library.add(faEye)
  library.add(faEyeSlash)
  library.add(faFileAlt)
  library.add(faFileChartLine)
  library.add(faFileContract)
  library.add(faFileExport)
  library.add(faFileImage)
  library.add(faFileImport)
  library.add(faFileInvoice)
  library.add(faFileUpload)
  library.add(falFileExcel)
  library.add(farFileContract)
  library.add(falFileUpload)
  library.add(faFlag)
  library.add(faFlagAlt)
  library.add(faFolder)
  library.add(farFont)
  library.add(faGlobe)
  library.add(faHandshake)
  library.add(faHeadset)
  library.add(faHourglassHalf)
  library.add(faInfoCircle)
  library.add(faKey)
  library.add(falExclamationTriangle)
  library.add(falKey)
  library.add(faLayerGroup)
  library.add(faLayerPlus)
  library.add(faList)
  library.add(faListAlt)
  library.add(faListDropdown)
  library.add(faLink)
  library.add(falListUl)
  library.add(faLocationDot)
  library.add(faLockAlt)
  library.add(faLockKeyhole)
  library.add(farLongArrowAltLeft)
  library.add(farLongArrowAltRight)
  library.add(faMapLocationDot)
  library.add(faMapMarkerAlt)
  library.add(faMerge)
  library.add(fasMerge)
  library.add(faMinus)
  library.add(falMinus)
  library.add(faMinusCircle)
  library.add(faMinusOctagon)
  library.add(faMinusSquare)
  library.add(faPencil)
  library.add(faPencilAlt)
  library.add(faPennant)
  library.add(faProjectDiagram)
  library.add(faPhone)
  library.add(faPhoneArrowUpRight)
  library.add(faPhoneFlip)
  library.add(falPhone)
  library.add(faPhoneSlash)
  library.add(faPlus)
  library.add(falPlus)
  library.add(faPlusSquare)
  library.add(farEllipsisV)
  // Pitch Library: the Settings menu entry and the lead panel's section header.
  // Registering is not optional — an unregistered icon renders as nothing at all,
  // which is how the Settings entry shipped without one.
  library.add(faPresentation)
  library.add(faPresentationScreen)
  library.add(faQrcode)
  library.add(faQuestionCircle)
  library.add(faReceipt)
  library.add(faRedo)
  library.add(faRepeat)
  library.add(falRepeat)
  library.add(farRetweet)
  library.add(faSearch)
  library.add(farShare)
  library.add(faShieldAlt)
  library.add(faSignOut)
  library.add(faSliders)
  library.add(faSolidFlag)
  library.add(faSolidSquare)
  library.add(faSortSizeUpAlt)
  library.add(faSpinner)
  library.add(faSquare)
  library.add(falSquareList)
  library.add(faStar)
  library.add(faStickyNote)
  library.add(faTable)
  library.add(farTask)
  library.add(faText)
  library.add(faTimes)
  library.add(faTimesCircle)
  library.add(fasTimesCircle)
  library.add(faTimesRegular)
  library.add(faTrash)
  library.add(faTrashAlt)
  library.add(falTrashAlt)
  library.add(farTrashAlt)
  library.add(farTrashCanXmark)
  library.add(farTrashUndoAlt)
  library.add(faTrophyAlt)
  library.add(faSitemap)
  library.add(faSync)
  library.add(faUser)
  library.add(faUsers)
  library.add(faUserCircle)
  library.add(faFilterCircleXmark)
  library.add(faUserChart)
  library.add(faUserCheck)
  library.add(faUserLock)
  library.add(faUserPlus)
  library.add(faUserTimes)
  library.add(farCog)
  library.add(farExclamationTriangle)
  library.add(farMapMarkerAlt)
  library.add(faWindowMinimize)
  library.add(faFileCheck)
  library.add(faFileExclamation)
  library.add(faExternalLink)
  library.add(faChartLine)
  library.add(faFilter)
  library.add(faExclamationCircle)
  library.add(faLineHeight)
  library.add(faAsterisk)
  library.add(faAddressBook)
  library.add(faPercentage)
  library.add(faArrowAltFromBottom)
  library.add(faDollarSign)
  library.add(faParagraph)
  library.add(faSortNumericUp)
  library.add(faPlay)
  library.add(faCalendarCheck)
  library.add(faScreenUsers)
  library.add(faPaperPlane)
  library.add(faCirclePlay)
  library.add(faArrowsFromDottedLine)
  library.add(faArrowUpRightAndArrowDownLeftFromCenter)
  library.add(faArrowDownLeftAndArrowUpRightToCenter)
  library.add(faArrowUpRightAndArrowDownLeftFromCenterReg)
  library.add(faArrowDownLeftAndArrowUpRightToCenterReg)
  library.add(faPaperclip)
  library.add(faMobileNotch)
  library.add(faSort)
  library.add(faBoxesStacked)
  library.add(faMinusOctagonReg)
  library.add(faDownload)
  library.add(faLineChart)
  library.add(faUpRightFromSquare)
  library.add(faSolidClock)
  library.add(faFileChartColumn)
  library.add(faUpload)
  library.add(faInboxIn)
  library.add(faInboxOut)
  library.add(faEnvelopeCircleCheck)
  library.add(faMessages)
  library.add(faArrowsToDottedLine)
  library.add(faGripLinesVertical)
  library.add(faArrowDownToDottedLine)
  library.add(farExclamationCircle)
  library.add(faPause)
  library.add(faCode)
  library.add(falHexagonMinus)
}
